import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const checks = [
  'check_1', 'check_2', 'check_3', 'check_4', 'check_5',
  'check_6', 'check_7', 'check_8', 'check_9', 'check_10',
];

export default function SoumissionContenu() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="soumission" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-4 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('soumission_h2')}
      </h2>
      <p className={`text-slate-primary/60 text-sm md:text-base mb-6 transition-all duration-1000 delay-100 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>
        {t('soumission_intro')}
      </p>

      <div className="space-y-3">
        {checks.map((c, idx) => (
          <div
            key={idx}
            className={`flex items-start gap-3 bg-soft-gray rounded-lg p-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 60 + 150}ms` }}
          >
            <div className="w-6 h-6 shrink-0 flex items-center justify-center rounded bg-copper/20 mt-0.5">
              <i className="ri-check-line text-copper text-sm" />
            </div>
            <p className="text-slate-primary/80 text-sm md:text-base">{t(c)}</p>
          </div>
        ))}
      </div>
    </section>
  );
}